import React from 'react';

const stats = [
  { value: '8', suffix: '+', label: 'ITSM Modules' },
  { value: '99.9', suffix: '%', label: 'Uptime SLA' },
  { value: '<2', suffix: 'min', label: 'Avg. Response Time' },
  { value: '100', suffix: '%', label: 'Role-Based Access' },
];

export default function Stats() {
  return (
    <section style={{ padding: '48px 0', borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)', background: 'rgba(255,255,255,0.015)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }} className="stats-grid">
        {stats.map(s => (
          <div key={s.label} style={{ textAlign: 'center' }}>
            <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '42px', fontWeight: 800, color: '#fff', letterSpacing: '-1px' }}>
              {s.value}<span style={{ color: '#52b788' }}>{s.suffix}</span>
            </div>
            <div style={{ fontSize: '13px', color: '#5a6a8a', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <style>{`@media(max-width:700px){ .stats-grid{ grid-template-columns:repeat(2,1fr) !important; } }`}</style>
    </section>
  );
}
